import { RULES_OF_USE_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

export default {
	[RULES_OF_USE_MODULE_ID]: {
		moduleType: 'static',
		staticPageType: 'rulesOfUse',
	},
}
